/* Homepage B only — countdown + compare accordion. Do not load on Homepage A. */
(function () {
  'use strict';

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function setDigit(root, unit, value) {
    var el = root.querySelector('[data-home-b-unit="' + unit + '"]');
    if (el) el.textContent = pad(value);
  }

  function expire(root) {
    root.setAttribute('data-home-b-expired', 'true');
    root.hidden = true;
    var live = document.querySelector('[data-home-b-live]');
    if (live) live.textContent = root.getAttribute('data-home-b-expired-label') || '';
    var banner = root.closest('[data-home-b-campaign]');
    if (banner && banner.getAttribute('data-home-b-hide-expired') === 'true') {
      banner.hidden = true;
    }
  }

  function tick(root, end) {
    var diff = end - Date.now();
    if (diff <= 0) {
      expire(root);
      return false;
    }
    root.hidden = false;
    root.removeAttribute('data-home-b-expired');
    var s = Math.floor(diff / 1000);
    setDigit(root, 'days', Math.floor(s / 86400));
    setDigit(root, 'hours', Math.floor((s % 86400) / 3600));
    setDigit(root, 'mins', Math.floor((s % 3600) / 60));
    setDigit(root, 'secs', s % 60);
    return true;
  }

  function initCountdown() {
    var roots = document.querySelectorAll('[data-home-b-countdown]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var end = Date.parse(root.getAttribute('data-home-b-end') || '');
      if (!end || isNaN(end)) {
        root.hidden = true;
        return;
      }
      if (!tick(root, end)) return;
      var id = setInterval(function () {
        if (!tick(root, end)) clearInterval(id);
      }, 1000);
    });
  }

  function setCmpHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
    el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    if (hidden) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function syncCompareA11y() {
    var desktop = document.querySelector('[data-home-b-cmp="desktop"]');
    var mobile = document.querySelector('[data-home-b-cmp="mobile"]');
    if (!desktop || !mobile) return;
    var isDesktop = window.matchMedia('(min-width: 990px)').matches;
    setCmpHidden(desktop, !isDesktop);
    setCmpHidden(mobile, isDesktop);
  }

  function initCompare() {
    syncCompareA11y();
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 990px)');
      if (mq.addEventListener) mq.addEventListener('change', syncCompareA11y);
      else if (mq.addListener) mq.addListener(syncCompareA11y);
    }
    var links = document.querySelectorAll('.home-b__compare-cta[href="#home-b-compare-table"]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 989px)').matches) {
          e.preventDefault();
          var more = document.querySelector('[data-home-b-compare-more]');
          if (more) {
            more.open = true;
            more.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  }

  function init() {
    initCountdown();
    initCompare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
